import SvgSlate from '@common/__generated__/icon/components/SvgSlate';
import { Button } from '@common/components/atom/Button/Button';
import { Input } from '@common/components/atom/Input/Input';
import { InputDecorator } from '@common/components/atom/InputDecorator/InputDecorator';
import { Modal } from '@common/components/atom/Modal/Modal';
import { useToast } from '@common/hooks';
import React, { useState } from 'react';

import { isValidUrl } from '../_utils/isValidUrl';

interface YouTubeButtonProps {
  youTubeUrl: string;
  onSubmit: () => void;
  onYouTubeUrlChange: (url: string) => void;
}

/**
 * 에디터 툴바의 유튜브 추가 버튼
 */
export const YouTubeButton = ({
  youTubeUrl,
  onSubmit,
  onYouTubeUrlChange,
}: YouTubeButtonProps) => {
  const { toast } = useToast();

  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <>
      <button
        className="flex size-24 items-center justify-center text-Gray-900"
        type="button"
        onClick={() => {
          setIsModalOpened(true);
        }}
      >
        <SvgSlate className="size-20" />
      </button>
      <Modal opened={isModalOpened} onClose={() => setIsModalOpened(false)}>
        <article className="mb-32 flex flex-col gap-16">
          <InputDecorator label="유튜브 주소">
            <Input
              placeholder="https://www.youtube.com/watch?v=ui6EbPMMkyw"
              value={youTubeUrl}
              onChange={(event) => onYouTubeUrlChange(event.target.value)}
            />
          </InputDecorator>
        </article>
        <footer className="flex w-full gap-8">
          <Button
            className="flex-1"
            onClick={() => {
              if (!isValidUrl(youTubeUrl)) {
                toast({
                  type: 'fail',
                  message: 'URL 형식이 아닙니다.',
                });

                return;
              }

              setIsModalOpened(false);
              onSubmit();
            }}
          >
            설정
          </Button>
          <Button
            className="flex-1"
            theme="sub-fill"
            onClick={() => {
              setIsModalOpened(false);
            }}
          >
            취소
          </Button>
        </footer>
      </Modal>
    </>
  );
};
